/* ============================================================
   MH Quick View — Global JavaScript
   ============================================================
   Loaded once in theme.liquid. Provides:
     - mhPrefetchProduct(handle)  — preload product data
     - mhQuickView(handle)        — open modal for a product
     - mhCloseQuickView()         — close modal
     - mhQvQty(delta)             — adjust qty
     - mhQvAddToCart()            — add current product to cart
     - mhQvPrevImg() / mhQvNextImg() / mhQvGoImg(i) — gallery nav
     - mhQvSelectVariant(optionIdx, valueIdx) — variant selector

   Any section can trigger QV simply by calling mhQuickView(handle).
   The single modal in mh-quick-view-modal.liquid renders all results.

   TODO (deferred):
     - Description HTML entity decoding (full safety)
     - Focus trap + focus restore for accessibility
     - Currency formatting via Shopify's money_format
============================================================ */

(function () {
  'use strict';

  /* ---------- State ---------- */
  var mhQvData = null;
  var mhQvImgs = [];
  var mhQvActiveImg = 0;
  var mhQvQtyVal = 1;
  var mhQvCache = {};
  var mhQvSelectedOptions = []; /* current option values, one per option group */
  var mhQvActiveVariant = null;

  /* ---------- Storefront API config (for live metafield rating fetch) ---------- */
  var MH_SF_DOMAIN = 'ub1qkg-1h.myshopify.com';
  var MH_SF_TOKEN  = '9ea3df030f348c8ea0d848c9742ecb36';
  var MH_SF_API    = '2025-01'; /* matches Buy Now version already in use */

  /* In-memory caches so reopening the same QV doesn't refetch */
  var mhQvRatingCache = {};       /* productId -> rating HTML */
  var mhQvShortDescCache = {};    /* productId -> short description HTML (string, may be '') */

  /* ---------- Rating: build star HTML (matches mh-rating snippet) ---------- */

  /* Empty state — 5 grey stars + (0). Matches Liquid snippet output for
     products with no reviews. Keeps visual consistency across all cards. */
  function mhQvBuildEmptyRatingHTML() {
    var STAR_POINTS = '12 2 15 9 22 9.5 17 14.5 18.5 22 12 18 5.5 22 7 14.5 2 9.5 9 9 12 2';
    var stars = '';
    for (var i = 0; i < 5; i++) {
      stars += '<svg class="mh-rating__star mh-rating__star--empty" viewBox="0 0 24 24" fill="currentColor" style="opacity:0.25">' +
                 '<polygon points="' + STAR_POINTS + '"/>' +
               '</svg>';
    }
    return '<div class="mh-rating mh-rating--md" aria-label="No reviews yet">' +
             '<div class="mh-rating__stars" aria-hidden="true">' + stars + '</div>' +
             '<span class="mh-rating__count">(0)</span>' +
           '</div>';
  }

function mhQvBuildRatingHTML(avg, count) {
  /* Star polygon shared by all three states — matches snippets/mh-rating.liquid */
  var STAR_POINTS = '12 2 15 9 22 9.5 17 14.5 18.5 22 12 18 5.5 22 7 14.5 2 9.5 9 9 12 2';

  /* Unique ID suffix per render so multiple QV opens don't collide on gradient IDs */
  var uid = 'qv-' + Date.now();

  var stars = '';
  var i;
  for (i = 1; i <= 5; i++) {
    var threshold = i - 0.5;

    if (avg >= i) {
      /* Full star */
      stars += '<svg class="mh-rating__star mh-rating__star--full" viewBox="0 0 24 24" fill="currentColor">' +
                 '<polygon points="' + STAR_POINTS + '"/>' +
               '</svg>';
    } else if (avg >= threshold) {
      /* Half star — uses gradient fill, needs unique ID */
      var gradId = 'mh-rating-half-' + uid + '-' + i;
      stars += '<svg class="mh-rating__star mh-rating__star--half" viewBox="0 0 24 24">' +
                 '<defs>' +
                   '<linearGradient id="' + gradId + '">' +
                     '<stop offset="50%" stop-color="currentColor"/>' +
                     '<stop offset="50%" stop-color="currentColor" stop-opacity="0.25"/>' +
                   '</linearGradient>' +
                 '</defs>' +
                 '<polygon points="' + STAR_POINTS + '" fill="url(#' + gradId + ')"/>' +
               '</svg>';
    } else {
      /* Empty star */
      stars += '<svg class="mh-rating__star mh-rating__star--empty" viewBox="0 0 24 24" fill="currentColor" style="opacity:0.25">' +
                 '<polygon points="' + STAR_POINTS + '"/>' +
               '</svg>';
    }
  }

  var avgDisplay = avg.toFixed(1);

  return '<div class="mh-rating mh-rating--md" aria-label="Rated ' + avgDisplay + ' out of 5 stars from ' + count + ' reviews">' +
           '<div class="mh-rating__stars" aria-hidden="true">' + stars + '</div>' +
           '<span class="mh-rating__count">(' + count + ')</span>' +
         '</div>';
}

  /* ---------- Storefront API: fetch reviews + short description in one query ---------- */
  /* Replaces the previous reviews-only fetch. Single network call retrieves
     both pieces of metafield data, keeping QV open fast. */

  function mhQvFetchProductMetafields(productId, ratingTargetEl, descTargetEl, fullDescriptionFallback) {
    if (!productId) return;

    /* Cache hits — render instantly without any network call */
    var hasRatingCache = mhQvRatingCache[productId] !== undefined;
    var hasShortDescCache = mhQvShortDescCache[productId] !== undefined;

    if (hasRatingCache && ratingTargetEl) {
      ratingTargetEl.innerHTML = mhQvRatingCache[productId];
    }
    if (hasShortDescCache && descTargetEl) {
      var cachedDesc = mhQvShortDescCache[productId];
      if (cachedDesc) {
        descTargetEl.innerHTML = cachedDesc;
      } else if (fullDescriptionFallback) {
        descTargetEl.innerHTML = fullDescriptionFallback;
      }
    }
    if (hasRatingCache && hasShortDescCache) return;

    /* product.id from /products/{handle}.js is numeric.
       Storefront API needs GID: gid://shopify/Product/{id} */
    var gid = 'gid://shopify/Product/' + productId;

    var query = 'query ProductData($id: ID!) {' +
                '  product(id: $id) {' +
                '    shortDescription: metafield(namespace: "custom", key: "short_description") { value type }' +
                '    reviews: metafield(namespace: "custom", key: "reviews") {' +
                '      references(first: 50) {' +
                '        nodes {' +
                '          ... on Metaobject {' +
                '            rating: field(key: "rating") { value }' +
                '          }' +
                '        }' +
                '      }' +
                '    }' +
                '  }' +
                '}';

    fetch('https://' + MH_SF_DOMAIN + '/api/' + MH_SF_API + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': MH_SF_TOKEN,
        'Accept': 'application/json'
      },
      body: JSON.stringify({ query: query, variables: { id: gid } })
    })
    .then(function (r) { return r.json(); })
    .then(function (json) {
      var data = (json && json.data && json.data.product) || {};

      /* ---- Short description ---- */
      if (!hasShortDescCache) {
        var shortDescRaw = data.shortDescription && data.shortDescription.value;
        var shortDescType = data.shortDescription && data.shortDescription.type;
        var shortDescHtml = '';

        if (shortDescRaw) {
          /* Metafield type may be:
             - rich_text_field → JSON structure that needs conversion
             - multi_line_text_field → plain text, preserve line breaks
             - single_line_text_field → plain text
             - html / etc. → already HTML
          */
          if (shortDescType === 'rich_text_field') {
            shortDescHtml = mhQvRichTextToHtml(shortDescRaw);
          } else if (shortDescType === 'multi_line_text_field') {
            shortDescHtml = mhQvEscapeText(shortDescRaw).replace(/\n/g, '<br>');
          } else if (shortDescType === 'single_line_text_field') {
            shortDescHtml = '<p>' + mhQvEscapeText(shortDescRaw) + '</p>';
          } else {
            /* Treat as HTML — sanitize light */
            shortDescHtml = mhQvSanitizeHtml(shortDescRaw);
          }
        }

        mhQvShortDescCache[productId] = shortDescHtml;

        if (descTargetEl) {
          if (shortDescHtml) {
            descTargetEl.innerHTML = shortDescHtml;
          } else if (fullDescriptionFallback) {
            /* Empty short description → fall back to full description (already in DOM) */
            descTargetEl.innerHTML = fullDescriptionFallback;
          }
        }
      }

      /* ---- Reviews / Rating ---- */
      if (!hasRatingCache && ratingTargetEl) {
        var nodes = data.reviews && data.reviews.references
                  ? data.reviews.references.nodes
                  : [];

        if (!nodes.length) {
          var emptyHtml = mhQvBuildEmptyRatingHTML();
          mhQvRatingCache[productId] = emptyHtml;
          ratingTargetEl.innerHTML = emptyHtml;
        } else {
          var total = 0;
          var count = 0;
          nodes.forEach(function (n) {
            var r = parseInt(n && n.rating && n.rating.value, 10);
            if (!isNaN(r) && r >= 1 && r <= 5) {
              total += r;
              count++;
            }
          });

          if (count === 0) {
            var emptyHtml2 = mhQvBuildEmptyRatingHTML();
            mhQvRatingCache[productId] = emptyHtml2;
            ratingTargetEl.innerHTML = emptyHtml2;
          } else {
            var avg = total / count;
            var ratingHtml = mhQvBuildRatingHTML(avg, count);
            mhQvRatingCache[productId] = ratingHtml;
            ratingTargetEl.innerHTML = ratingHtml;
          }
        }
      }
    })
    .catch(function (err) {
      console.warn('[MH QV] Metafield fetch failed:', err);
      /* On error: render the fallback (full description) so the modal isn't blank.
         Rating defaults to empty state. */
      if (!hasRatingCache && ratingTargetEl) {
        ratingTargetEl.innerHTML = mhQvBuildEmptyRatingHTML();
      }
      if (!hasShortDescCache && descTargetEl && fullDescriptionFallback) {
        descTargetEl.innerHTML = fullDescriptionFallback;
      }
    });
  }

  /* ---------- Rich text metafield → HTML ----------
     Shopify's rich_text_field stores JSON in this shape:
     { type: "root", children: [ { type: "paragraph", children: [...] }, ... ] }
     Each child has type ("text" | "paragraph" | "heading" | "list" | "link") and either
     value (for text leaves) or further children.
     This is a minimal converter — handles paragraphs, bold/italic, lists, links.
  */

  function mhQvRichTextToHtml(jsonStr) {
    var doc;
    try { doc = JSON.parse(jsonStr); } catch (e) { return ''; }
    if (!doc || !doc.children) return '';

    function renderNode(node) {
      if (!node) return '';
      switch (node.type) {
        case 'root':
          return (node.children || []).map(renderNode).join('');
        case 'paragraph':
          return '<p>' + (node.children || []).map(renderNode).join('') + '</p>';
        case 'heading':
          var lvl = Math.min(Math.max(parseInt(node.level, 10) || 2, 1), 6);
          return '<h' + lvl + '>' + (node.children || []).map(renderNode).join('') + '</h' + lvl + '>';
        case 'list':
          var tag = node.listType === 'ordered' ? 'ol' : 'ul';
          return '<' + tag + '>' + (node.children || []).map(renderNode).join('') + '</' + tag + '>';
        case 'list-item':
          return '<li>' + (node.children || []).map(renderNode).join('') + '</li>';
        case 'link':
          var href = mhQvEscapeAttr(node.url || '#');
          return '<a href="' + href + '" target="_blank" rel="noopener">' +
                 (node.children || []).map(renderNode).join('') +
                 '</a>';
        case 'text':
          var t = mhQvEscapeText(node.value || '');
          if (node.bold) t = '<strong>' + t + '</strong>';
          if (node.italic) t = '<em>' + t + '</em>';
          return t;
        default:
          /* Unknown node type — try to render children if present */
          return (node.children || []).map(renderNode).join('');
      }
    }

    return renderNode(doc);
  }

  /* Light HTML sanitizer — strips scripts/styles and disallows unsafe tags */
  function mhQvSanitizeHtml(html) {
    return String(html)
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/<style[\s\S]*?<\/style>/gi, '')
      .replace(/<(?!\/?(p|br|strong|em|b|i|ul|ol|li|span|a|h1|h2|h3|h4|h5|h6)\b)[^>]+>/gi, '');
  }

  function mhQvEscapeText(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function mhQvEscapeAttr(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ---------- Utilities ---------- */

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return 'Rs.' + numberWithCommas(amount) + ' PKR';
  }

  function $id(id) {
    return document.getElementById(id);
  }

  /* Decode common HTML entities present in product descriptions */
  function decodeHtmlEntities(str) {
    if (!str) return '';
    var ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
  }

  /* Escape HTML for safe insertion into innerHTML */
  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ---------- Prefetch ---------- */

  function mhPrefetchProduct(handle) {
    if (!handle || mhQvCache[handle]) return;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        mhQvCache[handle] = product;
        /* Also warm up the metafield cache (rating + short description) so
           when user clicks QV, both API calls have already resolved and
           the modal renders instantly with no flash. */
        mhQvWarmMetafields(product.id);
      })
      .catch(function () { /* silent */ });
  }

  /* Pre-warm rating + short description caches via Storefront API.
     Same fetch logic as mhQvFetchProductMetafields, but writes to caches
     only — no DOM updates. Called on hover for instant subsequent renders. */
  function mhQvWarmMetafields(productId) {
    if (!productId) return;
    if (mhQvRatingCache[productId] !== undefined && mhQvShortDescCache[productId] !== undefined) return;

    var gid = 'gid://shopify/Product/' + productId;
    var query = 'query ProductData($id: ID!) {' +
                '  product(id: $id) {' +
                '    shortDescription: metafield(namespace: "custom", key: "short_description") { value type }' +
                '    reviews: metafield(namespace: "custom", key: "reviews") {' +
                '      references(first: 50) {' +
                '        nodes {' +
                '          ... on Metaobject {' +
                '            rating: field(key: "rating") { value }' +
                '          }' +
                '        }' +
                '      }' +
                '    }' +
                '  }' +
                '}';

    fetch('https://' + MH_SF_DOMAIN + '/api/' + MH_SF_API + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': MH_SF_TOKEN,
        'Accept': 'application/json'
      },
      body: JSON.stringify({ query: query, variables: { id: gid } })
    })
    .then(function (r) { return r.json(); })
    .then(function (json) {
      var data = (json && json.data && json.data.product) || {};

      /* Cache short description */
      if (mhQvShortDescCache[productId] === undefined) {
        var shortDescRaw = data.shortDescription && data.shortDescription.value;
        var shortDescType = data.shortDescription && data.shortDescription.type;
        var shortDescHtml = '';

        if (shortDescRaw) {
          if (shortDescType === 'rich_text_field') {
            shortDescHtml = mhQvRichTextToHtml(shortDescRaw);
          } else if (shortDescType === 'multi_line_text_field') {
            shortDescHtml = mhQvEscapeText(shortDescRaw).replace(/\n/g, '<br>');
          } else if (shortDescType === 'single_line_text_field') {
            shortDescHtml = '<p>' + mhQvEscapeText(shortDescRaw) + '</p>';
          } else {
            shortDescHtml = mhQvSanitizeHtml(shortDescRaw);
          }
        }

        mhQvShortDescCache[productId] = shortDescHtml;
      }

      /* Cache rating */
      if (mhQvRatingCache[productId] === undefined) {
        var nodes = data.reviews && data.reviews.references
                  ? data.reviews.references.nodes
                  : [];

        if (!nodes.length) {
          mhQvRatingCache[productId] = mhQvBuildEmptyRatingHTML();
        } else {
          var total = 0;
          var count = 0;
          nodes.forEach(function (n) {
            var r = parseInt(n && n.rating && n.rating.value, 10);
            if (!isNaN(r) && r >= 1 && r <= 5) {
              total += r;
              count++;
            }
          });

          if (count === 0) {
            mhQvRatingCache[productId] = mhQvBuildEmptyRatingHTML();
          } else {
            var avg = total / count;
            mhQvRatingCache[productId] = mhQvBuildRatingHTML(avg, count);
          }
        }
      }
    })
    .catch(function () { /* silent — modal open will retry */ });
  }

  /* ---------- Variant resolution ---------- */

  /* Given the current mhQvSelectedOptions, find the matching variant. */
  function findVariantBySelection() {
    if (!mhQvData || !mhQvData.variants) return null;
    return mhQvData.variants.find(function (v) {
      for (var i = 0; i < mhQvSelectedOptions.length; i++) {
        var key = 'option' + (i + 1);
        if (v[key] !== mhQvSelectedOptions[i]) return false;
      }
      return true;
    }) || null;
  }

  /* Check if a given option-value would yield an available variant
     given the OTHER currently-selected option values. */
  function isOptionValueAvailable(optionIdx, value) {
    if (!mhQvData || !mhQvData.variants) return false;
    return mhQvData.variants.some(function (v) {
      for (var i = 0; i < mhQvData.options.length; i++) {
        var key = 'option' + (i + 1);
        if (i === optionIdx) {
          if (v[key] !== value) return false;
        } else {
          if (v[key] !== mhQvSelectedOptions[i]) return false;
        }
      }
      return v.available;
    });
  }

  /* ---------- Render variant selector ---------- */

  function renderVariants() {
    var container = $id('qv-variants');
    if (!container || !mhQvData) return;

    /* Skip rendering entirely if product has a single default variant */
    var isDefaultOnly =
      mhQvData.variants.length === 1 &&
      mhQvData.variants[0].title === 'Default Title';

    if (isDefaultOnly || !mhQvData.options || mhQvData.options.length === 0) {
      container.innerHTML = '';
      return;
    }

    var html = '';
    /* Shopify product.options is sometimes a plain array of strings (older API)
       and sometimes an array of objects with name/values (newer). Normalize. */
    var options = mhQvData.options.map(function (opt, i) {
      if (typeof opt === 'string') {
        /* Old format — derive values from variants */
        var values = [];
        mhQvData.variants.forEach(function (v) {
          var val = v['option' + (i + 1)];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        return { name: opt, values: values };
      }
      return opt;
    });

    options.forEach(function (opt, optionIdx) {
      html += '<div class="qv-option-group">';
      html += '<span class="qv-option-label">' + escapeHtml(opt.name) + '</span>';
      html += '<div class="qv-option-pills">';
      opt.values.forEach(function (val) {
        var isSelected = mhQvSelectedOptions[optionIdx] === val;
        var isAvailable = isOptionValueAvailable(optionIdx, val);
        var cls = 'qv-pill';
        if (isSelected) cls += ' is-selected';
        if (!isAvailable) cls += ' is-unavailable';
        /* Escape the value for safe inclusion inside a single-quoted JS string
           inside a double-quoted HTML attribute. */
        var safeJsVal = String(val)
          .replace(/\\/g, '\\\\')
          .replace(/'/g, "\\'")
          .replace(/"/g, '&quot;');
        html += '<button type="button" class="' + cls + '" ' +
                'onclick="mhQvSelectVariant(' + optionIdx + ", '" + safeJsVal + "')\"" +
                '>' +
                escapeHtml(val) +
                '</button>';
      });
      html += '</div>';
      html += '</div>';
    });

    container.innerHTML = html;
  }

  function mhQvSelectVariant(optionIdx, value) {
    mhQvSelectedOptions[optionIdx] = value;
    mhQvActiveVariant = findVariantBySelection();

    /* Update visible state */
    renderVariants();
    updatePriceAndButton();

    /* Swap main image to variant's featured image when available */
    if (mhQvActiveVariant && mhQvActiveVariant.featured_image) {
      var src = mhQvActiveVariant.featured_image;
      /* product.images is strings; featured_image is a string here in /products/handle.js */
      if (typeof src === 'object' && src.src) src = src.src;
      var withSize = src.replace(/(\.[^\.]+)$/, '_600x$1');

      /* Try to find this image in the gallery first */
      var idx = mhQvImgs.indexOf(withSize);
      if (idx !== -1) {
        mhQvGoImg(idx);
      } else {
        /* Not in the existing image array — display it as main image */
        var mainImg = $id('qv-main-img');
        if (mainImg) mainImg.src = withSize;
      }
    }
  }

  function updatePriceAndButton() {
    if (!mhQvActiveVariant) return;
    var priceEl = $id('qv-price');
    var addBtn = $id('qv-add-btn');
    var price = (mhQvActiveVariant.price / 100).toFixed(2);

    if (priceEl) priceEl.textContent = 'Rs.' + numberWithCommas(price) + ' PKR';
    if (addBtn) {
      var total = ((mhQvActiveVariant.price / 100) * mhQvQtyVal).toFixed(2);
      addBtn.textContent = mhQvActiveVariant.available
        ? 'Add to cart · Rs.' + numberWithCommas(total)
        : 'Sold out';
      addBtn.disabled = !mhQvActiveVariant.available;
    }
  }

  /* ---------- Render badges ---------- */
  /* Tag conventions (all case-insensitive):
       badge-dark:Name      → dark filled pill, UPPERCASE
       badge-outline:Name   → outlined pill, normal case
       badge:Name           → backward compat → dark filled pill, UPPERCASE
  */

  function renderBadges(product) {
    var badgesEl = $id('qv-badges');
    if (!badgesEl) return;

    var html = '';
    if (product.tags && product.tags.length > 0) {
      product.tags.forEach(function (tag) {
        var lower = tag.toLowerCase();
        var style = null;
        var text = null;

        if (lower.indexOf('badge-dark:') === 0) {
          style = 'dark';
          text = tag.substring('badge-dark:'.length);
        } else if (lower.indexOf('badge-outline:') === 0) {
          style = 'outline';
          text = tag.substring('badge-outline:'.length);
        } else if (lower.indexOf('badge:') === 0) {
          /* Legacy support */
          style = 'dark';
          text = tag.substring('badge:'.length);
        }

        if (!style || !text) return;

        if (style === 'dark') {
          html += '<span class="qv-badge qv-badge-dark">' + escapeHtml(text) + '</span>';
        } else {
          html += '<span class="qv-badge qv-badge-outline">' + escapeHtml(text) + '</span>';
        }
      });
    }
    badgesEl.innerHTML = html;
  }

  /* ---------- Render & open ---------- */

  function renderAndShow(product, handle) {
    mhQvData = product;
    mhQvActiveImg = 0;
    mhQvQtyVal = 1;

    /* Default variant selection — pick the FIRST AVAILABLE variant if possible */
    var firstAvailable = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    mhQvActiveVariant = firstAvailable;

    /* Build selected-options array from chosen variant's option1/2/3 */
    mhQvSelectedOptions = [];
    if (product.options && product.options.length) {
      for (var i = 0; i < product.options.length; i++) {
        mhQvSelectedOptions.push(firstAvailable['option' + (i + 1)]);
      }
    }

    var nameEl = $id('qv-name');
    var priceEl = $id('qv-price');
    var descEl = $id('qv-desc');
    var ratingEl = $id('qv-rating');
    var qtyEl = $id('qv-qty-val');
    var fullLink = $id('qv-full-link');
    var mainImg = $id('qv-main-img');
    var thumbsEl = $id('qv-thumbs');
    var overlay = $id('mh-qv-overlay');

    if (!overlay) {
      console.error('Quick view modal not found in DOM. Make sure {% render "mh-quick-view-modal" %} is in theme.liquid.');
      return;
    }

    if (nameEl) nameEl.textContent = product.title;

    /* Price + ATC text */
    updatePriceAndButton();

    /* ----- Description -----
       Strategy:
       1. Leave description blank initially. Avoids flashing full description
          before the short description (from Storefront API metafield) replaces it.
       2. Storefront API call (below) populates the SHORT description if the
          metafield exists, or falls back to the FULL description if empty.
       3. If the API fails entirely, the fallback HTML is used.
       For cached products, this renders instantly with no flash. */
    var fallbackDescHtml = '';
    if (descEl) {
      var rawHtml = product.description || '';
      fallbackDescHtml = mhQvSanitizeHtml(rawHtml);
      /* Keep blank for now — the Storefront API call decides what to render */
      descEl.innerHTML = '';
    }

    /* Rating + Short Description — fetched together in a single Storefront API call.
       Renders empty rating placeholder immediately, then replaces with real data.
       Short description replaces fallback description when present. */
    if (ratingEl) {
      ratingEl.innerHTML = mhQvBuildEmptyRatingHTML();
    }
    mhQvFetchProductMetafields(product.id, ratingEl, descEl, fallbackDescHtml);

    /* Gallery images — append _600x to filename for Shopify CDN sizing */
    mhQvImgs = (product.images || []).map(function (img) {
      return img.replace(/(\.[^\.]+)$/, '_600x$1');
    });
    if (mhQvImgs.length === 0) mhQvImgs = [''];

    if (mainImg) {
      mainImg.src = mhQvImgs[0];
      mainImg.alt = product.title || '';
      if (mainImg.complete) {
        mainImg.style.opacity = '1';
      } else {
        mainImg.style.opacity = '0';
        mainImg.onload = function () { mainImg.style.opacity = '1'; };
      }
    }

    /* Thumbnails */
    if (thumbsEl) {
      var thumbsHtml = '';
      mhQvImgs.forEach(function (src, i) {
        thumbsHtml += '<button type="button" class="qv-thumb ' + (i === 0 ? 'is-active' : '') + '" onclick="mhQvGoImg(' + i + ')" aria-label="View image ' + (i + 1) + '"><img src="' + src + '" alt=""></button>';
      });
      thumbsEl.innerHTML = thumbsHtml;
    }

    if (qtyEl) qtyEl.textContent = '1';
    if (fullLink) fullLink.href = '/products/' + handle;
    var buyBtn = $id('qv-buy-btn');
    if (buyBtn) {
      buyBtn.onclick = function () {
        if (!mhQvActiveVariant) return;
        /* Create an isolated checkout via Shopify Storefront API (GraphQL).
           Uses cartCreate mutation to get a checkoutUrl — creates a separate
           checkout session. Cart is NOT touched. */
        var variantGid = 'gid://shopify/ProductVariant/' + mhQvActiveVariant.id;
        var query = 'mutation { cartCreate(input: { lines: [{ merchandiseId: "' + variantGid + '", quantity: ' + mhQvQtyVal + ' }] }) { cart { checkoutUrl } userErrors { message } } }';

        fetch('/api/2025-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '9ea3df030f348c8ea0d848c9742ecb36'
          },
          body: JSON.stringify({ query: query })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var cart = data && data.data && data.data.cartCreate && data.data.cartCreate.cart;
          if (cart && cart.checkoutUrl) {
            window.location.href = cart.checkoutUrl;
          } else {
            var errors = data && data.data && data.data.cartCreate && data.data.cartCreate.userErrors;
            console.error('Checkout creation failed:', errors || data);
            window.location.href = '/products/' + handle;
          }
        })
        .catch(function (err) {
          console.error('Buy now error:', err);
          window.location.href = '/products/' + handle;
        });
      };
    }

    renderBadges(product);
    renderVariants();

    /* Open AFTER content is set */
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    /* Force card scroll to top — prevents the sheet from auto-scrolling
       past the title during re-render on mobile bottom sheets. */
    var card = $id('mh-qv-card');
    if (card) {
      card.scrollTop = 0;
      /* Repeat after a frame in case browser reflows asynchronously */
      requestAnimationFrame(function () { card.scrollTop = 0; });
    }
  }

  function mhQuickView(handle) {
    if (!handle) return;

    /* On mobile, skip QV and go to product page directly — better UX */
    if (window.innerWidth <= 880) {
      window.location.href = '/products/' + handle;
      return;
    }

    var overlay = $id('mh-qv-overlay');
    if (!overlay) {
      console.error('Quick view modal not found. Make sure {% render "mh-quick-view-modal" %} is in theme.liquid before </body>.');
      return;
    }

    if (mhQvCache[handle]) {
      /* Cached path: content is set BEFORE overlay becomes visible.
         Hide overlay first (in case it was left open from prior use),
         populate content, THEN show — zero flash. */
      var ov = $id('mh-qv-overlay');
      if (ov) {
        ov.classList.remove('is-open');
        ov.setAttribute('aria-hidden', 'true');
      }
      renderAndShow(mhQvCache[handle], handle);
      return;
    }

    /* Show overlay with loading state for uncached */
    var nameEl = $id('qv-name');
    var priceEl = $id('qv-price');
    var descEl = $id('qv-desc');
    var ratingEl = $id('qv-rating');
    var thumbsEl = $id('qv-thumbs');
    var mainImg = $id('qv-main-img');
    var addBtn = $id('qv-add-btn');
    var variantsEl = $id('qv-variants');
    var badgesEl = $id('qv-badges');

    if (nameEl) nameEl.textContent = 'Loading...';
    if (priceEl) priceEl.textContent = '';
    if (descEl) descEl.innerHTML = '';
    /* Render empty rating placeholder immediately to prevent layout shift */
    if (ratingEl) ratingEl.innerHTML = mhQvBuildEmptyRatingHTML();
    if (thumbsEl) thumbsEl.innerHTML = '';
    if (mainImg) mainImg.style.opacity = '0';
    if (addBtn) addBtn.textContent = 'Add to cart';
    if (variantsEl) variantsEl.innerHTML = '';
    if (badgesEl) badgesEl.innerHTML = '';

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    /* Reset scroll position for loading state */
    var card = $id('mh-qv-card');
    if (card) card.scrollTop = 0;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        mhQvCache[handle] = product;
        renderAndShow(product, handle);
      })
      .catch(function (err) {
        console.error('Quick view error:', err);
      });
  }

  /* ---------- Close ---------- */

  function mhCloseQuickView() {
    var overlay = $id('mh-qv-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ---------- Quantity ---------- */

  function mhQvQty(change) {
    mhQvQtyVal = Math.max(1, mhQvQtyVal + change);
    var qtyEl = $id('qv-qty-val');
    if (qtyEl) qtyEl.textContent = mhQvQtyVal;
    updatePriceAndButton();
  }

  /* ---------- Add to cart ---------- */
  /* Routes through the GLOBAL mhAddToCart() in mh-cart-drawer.liquid.    */
  /* The global function handles the spinner/tick/drawer-open feedback,   */
  /* keeping QV behavior identical to grid/favorites/shop-the-look.       */

  function mhQvAddToCart() {
    if (!mhQvData) return;
    if (!mhQvActiveVariant || !mhQvActiveVariant.available) return;

    var btn = $id('qv-add-btn');
    var variantId = mhQvActiveVariant.id;

    if (typeof window.mhAddToCart !== 'function') {
      console.error('mhAddToCart() is not defined. Make sure mh-cart-drawer section is rendered.');
      return;
    }

    /* Close QV modal right when cart drawer opens. */
    var originalCartOpen = window.mhCartOpen;
    window.mhCartOpen = function () {
      mhCloseQuickView();
      window.mhCartOpen = originalCartOpen;
      if (typeof originalCartOpen === 'function') originalCartOpen();
    };

    window.mhAddToCart(variantId, btn, mhQvQtyVal);
  }

  /* ---------- Gallery navigation ---------- */

  function mhQvGoImg(index) {
    if (index < 0 || index >= mhQvImgs.length) return;
    mhQvActiveImg = index;
    var mainImg = $id('qv-main-img');
    if (mainImg) mainImg.src = mhQvImgs[index];
    var thumbs = document.querySelectorAll('#qv-thumbs .qv-thumb');
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
    });
  }

  function mhQvNextImg() {
    if (mhQvImgs.length === 0) return;
    mhQvGoImg((mhQvActiveImg + 1) % mhQvImgs.length);
  }

  function mhQvPrevImg() {
    if (mhQvImgs.length === 0) return;
    mhQvGoImg((mhQvActiveImg - 1 + mhQvImgs.length) % mhQvImgs.length);
  }

  /* ---------- ESC key closes modal ---------- */

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var overlay = $id('mh-qv-overlay');
      if (overlay && overlay.classList.contains('is-open')) {
        mhCloseQuickView();
      }
    }
  });

  /* ---------- Auto-prefetch on hover for any element with [data-mh-qv-handle] ---------- */

  document.addEventListener('mouseenter', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var trigger = t.closest('[data-mh-qv-handle]');
    if (trigger) {
      mhPrefetchProduct(trigger.getAttribute('data-mh-qv-handle'));
    }
    /* Also prefetch when hovering the entire card (not just the eye icon) */
    var card = t.closest('.pgf-card');
    if (card) {
      var qvBtn = card.querySelector('[data-mh-qv-handle]');
      if (qvBtn) mhPrefetchProduct(qvBtn.getAttribute('data-mh-qv-handle'));
    }
  }, true);

  /* ---------- DOMContentLoaded preload ---------- */
  /* Prefetch all visible products on page load so first QV click is instant. */
  document.addEventListener('DOMContentLoaded', function () {
    var triggers = document.querySelectorAll('[data-mh-qv-handle]');
    triggers.forEach(function (t) {
      var handle = t.getAttribute('data-mh-qv-handle');
      if (handle) mhPrefetchProduct(handle);
    });
  });

  /* ---------- Expose to global scope ---------- */

  window.mhPrefetchProduct = mhPrefetchProduct;
  window.mhQuickView = mhQuickView;
  window.mhCloseQuickView = mhCloseQuickView;
  window.mhQvQty = mhQvQty;
  window.mhQvAddToCart = mhQvAddToCart;
  window.mhQvGoImg = mhQvGoImg;
  window.mhQvNextImg = mhQvNextImg;
  window.mhQvPrevImg = mhQvPrevImg;
  window.mhQvSelectVariant = mhQvSelectVariant;

})();